import { URL_PREFIX } from "../constants/stores";

export const updatePoAndStyle = async (token: string, po_id: number, style_id: number, po_no?: string, style_no?: string) => {

    try {
        const response = await fetch(`/allocation/updatePoStyle`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ po_id, po_no, style_id, style_no }),
        });
        if (response.status === 204) {
            return null;
        }
        const { data, message } = await response.json();
        return { data, message, statusCode: response.status };
    } catch (error) {
        console.log('Error fetching PONO:', error);
        return null;
    }
}

export const getAllocation = async (token: string, po_id: number, style_id: number) => {
    try {
        const response = await fetch(`${URL_PREFIX}/allocation/getAllocationByPoStyle`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ po_id, style_id }),
        });
        if (response.status === 204) {
            return null;
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.log('Error fetching PONO:', error);
    }
}

export const getAllocationById = async (token: string, allocation_id: number) => {
    try {
        const response = await fetch(`${URL_PREFIX}/allocation/getAllocationById`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ allocation_id }),
        });
        if (response.status === 204) {
            return null;
        }
        const { data } = await response.json();
        return data;
    } catch (error) {
        console.log('Error fetching allocation by ID: ', error);
    }
}

export const deleteAllocation = async (token: string, allocation_id: number): Promise<any> => {
    const response = await fetch(`/allocation/delete/${allocation_id}`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
    const data = await response.json();
    if (response.status === 200) {
        return true;
    }
    return false;
}


export const moveAllocation = async (token: string, allocations: number[], transferList: string[], po_no: string): Promise<any> => {
    const response = await fetch(`/allocation/moveAllocation`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ allocations, new_po_no: po_no, transferList })
    });
    const data = await response.json();
    if (response.status === 200) {
        return data;
    }
    return false;
}